import { z } from 'zod';
import { enqueueImgJobItemSchema } from '../enqueueImgJobs';
import { vaultPostRequest } from '../helpers';

const responseSchema = z.object({
  accepted: z.boolean(),
  enqueued: z.number(),
  duplicates: z.number(),
  enqueuedTuples: z.array(enqueueImgJobItemSchema),
});

export type IDryRunImgResponse = z.infer<typeof responseSchema>;

export async function dryRunImgApi(): Promise<IDryRunImgResponse> {
  return vaultPostRequest({ path: '/img/dry-run', body: {}, schema: responseSchema });
}
